import { Box } from "@mui/material";
import React from "react";

interface SetupErrorMessageProps {
  aiSetupError?: boolean;
  collabSetupError?: boolean;
}

export function SetupErrorMessage({
  aiSetupError,
  collabSetupError,
}: SetupErrorMessageProps): React.ReactNode {
  return (
    <Box sx={{ padding: "24px", textAlign: "center" }}>
      <h3 style={{ marginBottom: "16px", color: "#dc2626" }}>Setup Error</h3>
      {collabSetupError && (
        <p style={{ marginBottom: "8px" }}>
          Collaboration is not configured properly. Please check your TipTap Cloud credentials.
        </p>
      )}
      {aiSetupError && (
        <p style={{ marginBottom: "8px" }}>
          AI features are not configured properly. Please check your TipTap AI credentials.
        </p>
      )}
      <p style={{ marginTop: "16px", fontSize: "14px", color: "#6b7280" }}>
        Visit{" "}
        <a href="https://cloud.tiptap.dev" target="_blank" rel="noopener noreferrer">
          cloud.tiptap.dev
        </a>{" "}
        to get your credentials.
      </p>
    </Box>
  );
}
